import cn from 'classnames';
import React, { memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Image, Link } from 'components';
import Logo from 'components/Logo';

import { TUserType } from 'lib/models/User.model';

import styles from './Sidebar.module.scss';
import SlideShow from './SlideShow';

export interface SidebarProps {
  /** Custom class name */
  className?: string;
  /** Custom style */
  style?: Record<string, unknown>;
  isRecruiter?: boolean;
}

export const Sidebar: React.FC<SidebarProps> = memo(
  ({
    className = '', // custom class name
    style, // custom style
    isRecruiter = false,
  }: SidebarProps) => {
    const contentClassNames = cn(styles.container, className);

    const [t] = useTranslation('signin');

    const slideContent = useMemo(() => {
      const slideContent = [];
      const userType = isRecruiter ? TUserType.RECRUITER : TUserType.MANAGER;
      for (let i = 1; i <= 5; i++) {
        slideContent.push({
          title: t(`${userType}.slide-content.step-${i}.title`),
          description: t(`${userType}.slide-content.step-${i}.description`),
        });
      }
      return slideContent;
    }, []);

    const image = isRecruiter
      ? '/images/recruitment-signup.png'
      : '/images/society-signup.png';

    const slides = slideContent.map((slide, index) => (
      <div className={styles.slide} key={index}>
        <p className={styles.slideTitle}>{slide.title}</p>
        <p className={styles.slideDescription}>{slide.description}</p>
      </div>
    ));

    return (
      <div className={contentClassNames} style={style} data-testid="Sidebar">
        <div className={styles.content}>
          <Link href={'https://huzzle.app'}>
            <Logo
              name="huzzle-new"
              size="small"
              color="black"
              className={styles.logo}
            />
          </Link>
          <div className={styles.bannerContainer}>
            <Image
              src={image}
              alt={t('side-bar.alt-text')}
              className={styles.bannerContainerImage}
            />
            <SlideShow slides={slides} dotsClassName={styles.dotsSpacing} />
          </div>
        </div>
      </div>
    );
  }
);

Sidebar.displayName = 'Sidebar';
